export function useCanonicalUrl(story: any) {
  const route = useRoute()
  const config = useRuntimeConfig()
  const baseUrl = config.public.siteUrl

  return computed(() => {
    // Check if there's a custom canonical URL in Storyblok
    if (story.value?.content?.canonical 
    && story.value.content.canonical !== '' 
    && story.value.content.canonical !== null
    && story.value.content.canonical.cached_url !== ''
    && story.value.content.canonical.cached_url !== null) {
      let path = story.value.content.canonical.cached_url;
      // Remove trailing slash unless it's the root path
      path = path === '/' ? path : path.replace(/\/$/, '');
      return `${baseUrl}/${path}`.replace(/\/+/g, '/');
    }

    // Default canonical URL construction
    const path = route.path === '/' ? '' : route.path.replace(/\/$/, '');
    return `${baseUrl}${path}`;
  })
} 